<script setup lang="ts">
import {computed, defineEmits, ref} from "vue"
import {useContentStore} from "../store/content";
import {useStore} from "../store";

const emit = defineEmits(["toggle"])
const store = useStore()
const contentItem = useContentStore()
const selectedLang = ref(contentItem.itemId)

export type ActionButton = {
    label: string, // display text
    action: string, // action to perform
    selected: boolean, // display style
    onclick: () => void | boolean, // callback
}

const buttons = computed((): ActionButton[] => {
    let buttons: ActionButton[] = []
    for (const language of contentItem.languages){
        buttons.push({
            label: language.name,
            selected: language.id === selectedLang.value,
            action: `${language.id}-${language.id === selectedLang.value}`,
            onclick: () => {
                selectedLang.value = language.id
            }
        } as ActionButton)
    }
    return buttons
})

function handleSubmit(e: MouseEvent){
    e.preventDefault()
    emit('toggle')
    if (selectedLang.value !== store.itemId)
        store.switchItem(selectedLang.value)
}
</script>

<template>
    <div class="fixed inset-0 z-[999] grid h-screen w-screen place-items-center">
        <div class="bg-mono-ns-100 rounded-3xl w-[295px] flex flex-col p-6 xl:p-10 font-sans">

            <div class="flex flex-col gap-4 xl:gap-6 mb-6 xl:mb-10 items-center xl:items-start">

                <div class="flex flex-col gap-6">
                    <h1 class="text-h3m xl:text-tf3 font-bold text-mono-white text-center xl:text-left">Language</h1>
                </div>
            </div>
            <div class="btn-wrapper flex flex-col  items-center mb-4">
                <button type="button" v-for="button in buttons" :key="button.action"
                    class="flex items-center gap-2 p-4 cursor-pointer font-bold text-center text-mono-white w-full hover:bg-mono-ns-200"
                    :class="{'bg-mono-ns-200': button.selected}"
                    @click="button.onclick">
                    <svg v-if="button.selected" class="w-4 h-4 checked" xmlns="http://www.w3.org/2000/svg">
                        <use href="#icon-check"></use>
                    </svg>
                    {{button.label}}
                </button>
            </div>
            <button type="button" class="p-2.5 self-end font-bold text-mono-white mb-4 xl:mb-0" @click="handleSubmit">
                OK
            </button>
        </div>
    </div>
</template>

